import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import { Link, useParams } from 'react-router-dom'
import * as AnalyticsService from '../../services/analytics'
import { useAnalyticsFilters } from '../../contexts/AnalyticsFilterContext'
import AnalyticsPageShell from './components/AnalyticsPageShell'
import MetricsSection from './components/MetricsSection'
import InsightsPanel from './components/InsightsPanel'
import BarSeriesChart from './components/BarSeriesChart'
import { getAnalyticsErrorMessage } from './utils'

const WorkshopDetail = () => {
    const { id } = useParams()
    const { startDate, endDate } = useAnalyticsFilters()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [detail, setDetail] = useState(null)

    useEffect(() => {
        let cancelled = false

        async function load() {
            setLoading(true)
            setError(null)
            try {
                const data = await AnalyticsService.getWorkshopDetail(id, { startDate, endDate })
                if (!cancelled) setDetail(data)
            } catch (err) {
                if (!cancelled) setError(getAnalyticsErrorMessage(err))
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        load()
        return () => {
            cancelled = true
        }
    }, [id, startDate, endDate])

    return (
        <AnalyticsPageShell
            title={`Análises de negócio — ${detail?.workshopName || `Oficina ${id}`}`}
            loading={loading}
            error={error}
        >
            <div style={{ marginBottom: 12 }}>
                <Button component={Link} to='/dashboard/analytics/workshops' size='small' variant='outlined'>
                    ← Voltar para oficinas
                </Button>
            </div>
            <MetricsSection title='Métricas' metrics={detail?.metrics} />
            <BarSeriesChart title='Principais tipos de manutenção' points={detail?.topMaintenanceTypes} />
            <InsightsPanel insights={detail?.insights} />
        </AnalyticsPageShell>
    )
}

export default WorkshopDetail
